import { all, call, fork, put, select, take } from 'redux-saga/effects';

import {
  RESET_ANNOTATION, SAVE_ANNOTATION_POSITION, 
  SET_TOUCH_EVENT_STATUS,
  TOGGLE_NOTE,
  SAVE_EBOOK, SAVE_SELECTEDHIGHLIGHT,
  PIPEROUTER__NAVIGATION, SET_ISLOADING,
  getNavigationInfo, notifications
} from './actions';

import { annoWidth, annoHeight, menuHeight, VitalSourceEvents as vsEvents } from 'Lib/constants.js';
import { getPreviousPageInfo, getNextPageInfo } from 'Services/learnkit';

let lastScroll;

function _constructSelectedHighlight(highlightId, highlights, markers, notes) {
  const selectedHighlight = highlights.filter(highlight => {
    return highlight.id === highlightId;
  });
  const marker = markers.filter(marker => {
    return marker.id === selectedHighlight[0].markerId;
  });
  const note = notes.filter(note => {
    return note.id === highlightId;
  });

  return {
    color: marker[0].color,
    darkColor: marker[0].darkColor,
    label: marker[0].label,
    markerId: marker[0].id,
    noteText: note[0] ? note[0].text : '',
    id: selectedHighlight[0].id
  };
}

function* bookClick() {
  while (true) {
    yield take(vsEvents['book:click']);
    yield put({ type: RESET_ANNOTATION });
  }
}

function* bookNavigationRequested() {
  while (true) {
    yield take(vsEvents['book:navigationRequested']);
    yield put({
      type: PIPEROUTER__NAVIGATION,
      data: {
        cmd: 'EXIT_SNIPPET'
      }
    });
  }
}

function* bookSelectionMade() {
  while (true) {
    const { data } = yield take(vsEvents['book:selectionMade']);
    // document.getElementById('dbugger').innerHTML += ` ---------bookSelectionMade()`;
  }
}

function* bookSelection() {
  while (true) {
    const { data } = yield take(vsEvents['book:selectionWithPosition']);
    // console.log('pipelines/bindVitalSourceEvents/index.js bookSelection()', data);
    // document.getElementById('dbugger').innerHTML += ` -----------bookSelection()-selectedText-${data.selectedText}`;

    const annotation = yield select(state => {
      return state.annotation;
    });
    const isTouchScreen = annotation.isTouchScreen;

    const { innerHeight: viewportHeight, innerWidth: viewportWidth } = window;
    const { top: cursorTop, left: cursorLeft } = data.eventPosition;
    const { top: topOffset, bottom: boxBottom } = data.selectionRect;

    // READ-1417: Give some extra space for mobile text select
    const boxBottomAdjusted = boxBottom + 10;
    const topOffsetAdusted = topOffset - 10;

    let arrowPlacement = 'top';
    let placeAnnoTop = boxBottomAdjusted;                          //place at bottom of selection
    let placeAnnoLeft = viewportWidth / 2 - annoWidth / 2; //place at center

    const { isOpen, isMain, highlightId } = yield select(state => state.annotation);

    if ( !isTouchScreen && (!isOpen || !isMain || highlightId) ) {
      yield put({ type: RESET_ANNOTATION });
    }

    //how far off the bottom?
    const bottomOffset = viewportHeight - boxBottomAdjusted - menuHeight;
    if (bottomOffset <= annoHeight) {
      console.log('TOO CLOSE TO THE BOTTOM', bottomOffset);
      arrowPlacement = 'bottom';
      placeAnnoTop = topOffsetAdusted - annoHeight;
    }

    //how far off the top?
    if (topOffsetAdusted <= annoHeight) {
      console.log('TOO CLOSE TO THE TOP', topOffsetAdusted);
      placeAnnoTop = boxBottomAdjusted;
    }

    const annoPosition = {
      x: Math.floor(placeAnnoLeft),
      y: Math.floor(placeAnnoTop),
      arrow: arrowPlacement
    };

    yield put({
      type: SAVE_ANNOTATION_POSITION,
      data: {
        isOpen: true,
        isMain: true,
        position: annoPosition,
        textSelected: true,
        highlightClicked: false,
        noteClicked: false
      }
    });
  }
}

function* highlightClick() {
  while (true) {
    const { data } = yield take(vsEvents['highlight:click']);
    const { innerHeight:viewportHeight, innerWidth:viewportWidth } = window;
    const { height:boxHeight, width:BoxWidth, top:topOffset } = data.position;
    const { syncId:highlightId } = data;

    let arrowPlacement = 'top';
    let placeAnnoTop = topOffset + boxHeight; //default is bottom of highlight
    let placeAnnoLeft = viewportWidth / 2 - annoWidth / 2; //default is center

    yield put({ type: RESET_ANNOTATION });

    const { highlights, markers, notes } = yield select(state => {
      return {
        highlights: state.highlights,
        markers: state.markers,
        notes: state.notes
      };
    });

    const selectedHighlight = _constructSelectedHighlight(highlightId, highlights, markers, notes);

    //how far off the bottom?
    const bottomOffset = viewportHeight - (topOffset + boxHeight);
    if (bottomOffset <= annoHeight) {
      console.log('TOO CLOSE TO THE BOTTOM', bottomOffset);
      arrowPlacement = 'bottom';
      placeAnnoTop = topOffset - annoHeight;
    }

    //how far off the top?
    if (topOffset <= annoHeight) {
      console.log('TOO CLOSE TO THE TOP', topOffset);
      placeAnnoTop = topOffset + boxHeight;
    }

    const annoPosition = {
      x: Math.floor(placeAnnoLeft),
      y: Math.floor(placeAnnoTop),
      arrow: arrowPlacement
    };

    yield put({ type: SAVE_SELECTEDHIGHLIGHT, data: selectedHighlight });
    yield put({
      type: SAVE_ANNOTATION_POSITION,
      data: {
        isOpen: true,
        highlightId,
        position: annoPosition,
        textSelected: false,
        highlightClicked: true,
        noteClicked: false
      }
    });
  }
}

function* noteIconClick() {
  while (true) {
    const { data } = yield take(vsEvents['noteicon:click']);

    const {
      annotation, highlights, markers, notes,
      selectedHighlight:prevSelectedHighlight
    } = yield select(state => {
      return {
        annotation: state.annotation,
        highlights: state.highlights,
        markers: state.markers,
        notes: state.notes,
        selectedHighlight: state.selectedHighlight
      };
    });

    const { syncId:newHighlightId, position:{ height:iconHeight, left, top } } = data;
    const annoPosition = {
      x: left + 10,
      y: top + iconHeight
    };

    const selectedHighlight = _constructSelectedHighlight(newHighlightId, highlights, markers, notes);

    yield put({
      type: TOGGLE_NOTE,
      data: {
        position: annoPosition,
        selectedHighlight
      }
    });
  }
}

function* pageBreak() {
  while (true) {
    const { data } = yield take(vsEvents['book:pagebreak']);
    yield put({ type: 'SAVE_BOOK_PAGE_BREAK', data });
  }
}

function* unSelectHighlight() {
  while (true) {
    const { data } = yield take(vsEvents['book:selectionCancelled']);

    const { isTouchScreen, isOpen, isMain, textSelected, highlightClicked, noteClicked } = yield select(state => state.annotation);

    if (!textSelected) {
      yield;
    }

    /*
     VS book:selectionCancelled event is called immediately after
     highlight:click and noteicon:click events. This logic
     ignores the book:selectionCancelled event immediately after
     these two events that cause an "open" state of the annotation tool.
     This event gives us a chance to reset the highlightClicked and noteClicked
     state to indicate that the inital click event has passed, and the annotation
     tool can be reset successfully on the next book:selectionCancelled which will
     indicate a real user interaction.
    */
    if (isOpen) {
      const isNotNoteClickEvent = !isMain && !noteClicked;
      const isNotHighlightClickEvent = isMain && !highlightClicked;
      const isMouseHighlightEvent = isMain && textSelected;

      if (!isTouchScreen && (isNotHighlightClickEvent || isNotNoteClickEvent || isMouseHighlightEvent)) {
        yield put({ type: RESET_ANNOTATION });
      }
    }

    yield put({ 
      type: SAVE_ANNOTATION_POSITION,
      data: {
        highlightClicked: false,
        noteClicked: false
      }
    })
  }
}

function* pageLoad() {
  while (true) {
    const { data:{ cfi } } = yield take(vsEvents['page:load']);
    const { ebook, fromSnippetExit } = yield select(state => state.reader);

    if (fromSnippetExit) {
      yield put({ type: SAVE_EBOOK, data: { ...ebook, cfi }});
    }
  }
}

function* pageReady() {
  while (true) {
    yield take([
      vsEvents['snippet:ready'],
      vsEvents['page:load'],
    ]);

    yield put(getNavigationInfo());
    yield put(notifications(SET_ISLOADING, false));
  }
}

function* pageScroll() {
  while (true) {
    const { data:{ cfi, scrollTop } } = yield take(vsEvents['page:scroll']);
    const { annoPosition:currAnnoPosition, currentCfi, openAnnotations } = yield select(state => {
      return {
        annoPosition: state.annoPosition,
        currentCfi: state.currentCfi,
        openAnnotations: state.openAnnotations
      };
    });

    //CFI value is determined at the top of the viewport
    const _cfi = cfi.split('@')[0];
    const prevScrollTop = lastScroll;
    const delta = prevScrollTop - scrollTop;

    lastScroll = scrollTop;

    if (currentCfi !== _cfi) {
      yield fork(saveScrollCfi, { cfi: _cfi, scrollTop });
    }

    if (openAnnotations) {
      const { x, y } = currAnnoPosition;
      const annoPosition = {
        x,
        y: y + delta,
        arrow: 'top'
      };

      yield put({ type: 'SAVE_ANNOTATION_POSITION', data: annoPosition });
    }
  }
}

function* saveScrollCfi({ cfi, scrollTop }) {

  // console.log('scrollTop', scrollTop);
  // console.log('scrollTop + height', scrollTop + 777);
  // console.log('scrollTop + height', 5102 - (scrollTop + 777));

  yield put({ type: 'SAVE_SCROLL_CFI', data: { cfi, scrollTop } });
}

function* bookTouchStart() {
  while (true) {
    const { data } = yield take(vsEvents['book:touchstart']);

    yield put({
      type: SET_TOUCH_EVENT_STATUS,
      data: {
        touchEventInProgress: true,
        isTouchScreen: true
      }
    });
  }
}

function* bookTouchEnd() {
  while (true) {
    const { data } = yield take(vsEvents['book:touchend']);

    yield put({
      type: SET_TOUCH_EVENT_STATUS,
      data: {
        touchEventInProgress: false,
        isTouchScreen: true
      }
    });
  }
}

function* bookTouchMove() {
  while (true) {
    const { data } = yield take(vsEvents['book:touchmove']);

    yield put({
      type: SET_TOUCH_EVENT_STATUS,
      data: {
        isTouchScreen: true
      }
    });
  }
}

function* listenToVitalSourceEvents() {
  yield all([
    bookTouchStart(),
    bookTouchEnd(),
    bookTouchMove(),
    bookClick(),
    bookNavigationRequested(),
    bookSelectionMade(),
    bookSelection(),
    highlightClick(),
    pageBreak(),
    pageScroll(),
    noteIconClick(),
    pageLoad(),
    pageReady(),
    unSelectHighlight()
  ]);
}


export default listenToVitalSourceEvents;
